import { Component, OnInit, HostListener } from "@angular/core";
import * as loginStrings from "../stringFiles/newLogin.json";
import { NewLoginServices } from "./new-login.service";
import { NewLoginWithDomainVerificationServices } from "../new-login-with-domain-verification/new-login-with-domain-verification.service";
import { firstValueFrom } from "rxjs";
import { commonFunctionService } from "../utils/commonFunctions";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { BrandService } from "../brand/brand.service";

declare var $: any;
declare var customToastr: any;
@Component({
  selector: "app-new-login",
  templateUrl: "./new-login.component.html",
  styleUrls: ["./new-login.component.css"],
  providers: [NewLoginServices, NewLoginWithDomainVerificationServices],
})
export class NewLoginComponent implements OnInit {
  showPasswordInput: boolean = true;
  loginError: boolean = true;
  userEmail: string;
  password: string;
  loginDebounceTimer: any;
  emailAddressLength: any = 0;
  passwordLength: any = 0;
  isEmailAddressValid: boolean = false;
  isPasswordValid: boolean = false;
  messages = [];
  otpVerificationPage: boolean = false;
  showPasswordPage: boolean = false;
  otp: string[] = ["", "", "", ""];
  otpInputsFilled: boolean = false;
  getAuthToken: any;
  errorMessage: any = {
    userEmail: "",
    password: "",
  };
  notVerifiedSchoolDetails: boolean;
  loginStrings: any = loginStrings;
  countdown: number;
  otpTime: number = 30;
  loader: boolean = false;
  currentIndex: number;
  isLoginApiCalled: boolean = false;
  loginWithSchoolURL: boolean = false;
  preLoader: boolean = false;
  isForgotPassword: boolean = false;
  confirmNewPassword: string;
  isResetPassword: boolean = false;
  otpForForgotPassword: string[] = ["", "", "", ""];
  isGoBack: boolean = false;
  langChangeSub: any;
  brand = this.brandService.brand;

  togglePasswordInput() {
    this.showPasswordInput = !this.showPasswordInput;
  }
  constructor(
    private newLoginServices: NewLoginServices,
    private newLoginWithDomainVerificationService: NewLoginWithDomainVerificationServices,
    private commonFunction: commonFunctionService, private translate: TranslateService,
    private brandService: BrandService
  ) {
    this.generateRandomIndex();
    this.initScript();
    this.notVerifiedSchoolDetails = false;
  }
  ngOnInit() {
    this.checkSession();
    this.loadQuotes();
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadQuotes();
    });
  }

   loadQuotes() {
    this.translate.get('LOGIN_QUOTES').subscribe((quotes: any[]) => {
      this.messages = quotes;
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  // Function to get a cookie

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }

  //Displaying Random Quotes
  generateRandomIndex(): void {
    this.currentIndex = Math.floor(Math.random() * this.messages.length);
  }

  //Email address debouncing function
  handleDebounceEmail(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerLoginEmailError(value);
    }, 800);
  }

  //Password debouncing function
  handleDebouncePassword(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerLoginPasswordError(value);
    }, 800);
  }

  //Email address validation function
  triggerLoginEmailError(input: any) {
    const emailAddress = input.value.trim();
    this.emailAddressLength = emailAddress.length;
    this.userEmail = emailAddress;
    if (this.emailAddressLength < 2 && this.emailAddressLength > 0) {
      this.errorMessage.userEmail =
        this.loginStrings.errorMessageForUserOrEmailAddress;
      this.isEmailAddressValid = false;
    } else {
      this.errorMessage.userEmail = "";
      this.isEmailAddressValid = true;
    }
  }

  triggerLoginPasswordError(input: any) {
    const passwordInput = input.value.trim();
    this.passwordLength = passwordInput.length;
    this.password = passwordInput;
  }

  submitOtpVerificationPage() {
    this.genericLoginWithOtp();
  }

  handleOnclickPassword() {
    this.otpVerificationPage = false;
    this.showPasswordInput = true;
  }

  moveToNext(event: KeyboardEvent, index: number) {
    const keyPressed = event.key;
    const isNumber = !isNaN(Number(keyPressed));

    // If the key is not a number or backspace, prevent default behavior
    if (!isNumber && event.key !== this.loginStrings.backspace) {
      event.preventDefault();
      return;
    }

    // If the backspace key is pressed and the input field is empty, focus on the previous input field
    if (
      event.key === this.loginStrings.backspace &&
      index > 0 &&
      event.target instanceof HTMLInputElement
    ) {
      const previousInput = document.getElementById(
        "otp-input-" + (index - 1)
      ) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
    }

    // If a number key is pressed and the current input field is not the last one, focus on the next input field
    if (isNumber && index < 3) {
      const nextInput = document.getElementById(
        "otp-input-" + (index + 1)
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
    this.otpInputsFilled = this.allOtpInputsFilled();
  }

  handleKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      "ArrowLeft",
      "ArrowRight",
      "Backspace",
      "Delete",
      "Home",
      "End",
    ];
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  clearInputValues() {
    this.userEmail = "";
    this.password = "";
    this.emailAddressLength = 0;
    this.passwordLength = 0;
    this.otp = [];
    this.confirmNewPassword = ""
    this.isResetPassword = false;
    this.isForgotPassword = false;
    this.otpForForgotPassword = ["", "", "", ""]
    this.isGoBack = false;
  }

  allOtpInputsFilled(): boolean {
    return this.otp.every((input) => input.trim() !== "");
  }

  otpTimerCountdown() {
    this.otpTime = 30;
    const interval = setInterval(() => {
      if (this.countdown > 0) {
        if (this.otpTime > 0) {
          this.otpTime--;
        } else {
          clearInterval(interval);
        }
      }
    }, 1000);
  }

  async genericLoginWithOtp() {
    try {
      this.loader = true;
      this.otp = ["", "", "", ""];
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        userName: this.userEmail,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginServices.genericLoginWithOtpApi(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body && responseDetails.body.attemptLeft) {
          this.countdown = responseDetails.body.attemptLeft;
          this.otpVerificationPage = true;
          this.otpTime = 30;
          this.otpTimerCountdown();
          customToastr(responseDetails.body.message, this.loginStrings.success);
        }
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }
  async genericLoginWithPassword() {
    try {
      this.loader = true;
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        userName: this.userEmail,
        password: this.password,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginServices.genericLoginWithPasswordApi(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.schoolInfo &&
          responseDetails.body.schoolInfo.isSchoolVerified &&
          responseDetails.body.schoolInfo.token
        ) {
          const schoolInfoDetails = responseDetails.body.schoolInfo.schoolInfo;
          if (schoolInfoDetails) {
            // Previously compared window.location.hostname against the
            // literal "app.bluewings.in", which only ever matched on that
            // one exact host — every other brand's "app.<domain>" URL (and
            // any bluewings subdomain other than "app") silently fell
            // through this whole block, so login "succeeded" (the toast
            // fired) but never wrote the session cookies or redirected.
            // The actual intent is "this is a real deployed domain, not
            // local dev", which the urlHost !== localhost check elsewhere
            // in this file already expresses correctly.
            if (window.location.hostname.split(".")[1] !== this.loginStrings.localhost) {
             this.commonFunction.setCookie('extensionServices',responseDetails.body.schoolInfo.schoolExtensionServicePermissions ?JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions):null, 7);
              this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);
              this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookie(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookie(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookie(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookie(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookie(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
              this.commonFunction.setCookie(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
              const d = {};
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookie(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);
              const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
              let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
              this.getAuthToken = tokenValue;
              const subDomain = schoolInfoDetails.SchoolDomain
              const protocol = window.location.protocol + "//";
              const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
              let redirectUrl = "";
              if (schoolInfoDetails.isFranchise == 1) {
                redirectUrl = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsFranchiseDashboardPath;
              } else {
                redirectUrl = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsDashboardPath;
              }
              this.commonFunction.disableBackButton()
              customToastr(responseDetails.body.message, this.loginStrings.success);
              window.location.href = redirectUrl;
              this.clearInputValues();
            }
          }
        } else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed) {
          const subDomain = responseDetails.body.schoolInfo.schoolDomain
          const protocol = window.location.protocol + "//";
          const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
          this.commonFunction.setCookie('extensionServices',responseDetails.body.schoolInfo.schoolExtensionServicePermissions?JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions):null, 7);
          this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
          this.commonFunction.setCookie(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
          this.commonFunction.setCookie(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          this.commonFunction.disableBackButton();
          customToastr(responseDetails.body.message, this.loginStrings.success);
          window.location.href = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsSchoolUnderVerificationPath;
        }
        else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed === false) {
          const subDomain = responseDetails.body.schoolInfo.schoolDomain
          const protocol = window.location.protocol + "//";
          const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
          this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
          this.commonFunction.disableBackButton()
          customToastr(responseDetails.body.message, this.loginStrings.success);
          window.location.href = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsSchoolDetailsPath;
        }
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }

  async verifyingOtpForGenericLogin() {
    try {
      this.loader = true;
      const otpForEmail = this.otp.join("");
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        emailId: this.userEmail,
        otpForEmail: otpForEmail,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginServices.verifyingOtpForGenericLoginApi(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.schoolInfo &&
          responseDetails.body.schoolInfo.isSchoolVerified &&
          responseDetails.body.schoolInfo.token
        ) {
          const schoolInfoDetails = responseDetails.body.schoolInfo.schoolInfo;
          if (schoolInfoDetails) {
            // See the identical guard in genericLoginWithPassword() above
            // for why this can't be an exact hostname match.
            if (window.location.hostname.split(".")[1] !== this.loginStrings.localhost) {
              this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);

             this.commonFunction.setCookie('extensionServices',responseDetails.body.schoolInfo.schoolExtensionServicePermissions?JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions):null, 7);

              this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookie(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookie(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookie(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookie(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookie(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
              this.commonFunction.setCookie(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
              const d = {};
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookie(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);
              const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
              let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
              this.getAuthToken = tokenValue;
              const subDomain = schoolInfoDetails.SchoolDomain
              const protocol = window.location.protocol + "//";
              const hostName = window.location.hostname;
              const urlHost = hostName.split(".")[1];
              const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
              let redirectUrl = "";
              if (urlHost === this.loginStrings.localhost) {
                redirectUrl = protocol + subDomain + "." + urlHost + this.loginStrings.localHostDashboardPath;
              }
              else {
                if (schoolInfoDetails.isFranchise == 1) {
                  redirectUrl = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsFranchiseDashboardPath;
                } else {
                  redirectUrl = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsDashboardPath;
                }
              }
              customToastr(responseDetails.body.message, this.loginStrings.success);
              this.commonFunction.disableBackButton()
              window.location.href = redirectUrl;
              this.clearInputValues();
            }
          }
        } else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed) {
          const subDomain = responseDetails.body.schoolInfo.schoolDomain
          const protocol = window.location.protocol + "//";
          const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
          this.commonFunction.setCookie('extensionServices',responseDetails.body.schoolInfo.schoolExtensionServicePermissions?JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions):null, 7);
          this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
          this.commonFunction.setCookie(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
          this.commonFunction.setCookie(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          customToastr(responseDetails.body.message, this.loginStrings.success);
          window.location.href = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsSchoolUnderVerificationPath;
        }
        else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed === false) {
          const subDomain = responseDetails.body.schoolInfo.schoolDomain
          const protocol = window.location.protocol + "//";
          const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
          this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
          customToastr(responseDetails.body.message, this.loginStrings.success);
          window.location.href = protocol + subDomain + "." + domainSuffix + this.loginStrings.bluewingsSchoolDetailsPath;
        }
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }
  resendOtp() {
    this.genericLoginWithOtp();
  }
  submitPasswordVerification() {
    this.genericLoginWithPassword();
  }

  openRegisterLink() {
    const protocol = window.location.protocol;
    const hostName = window.location.hostname;
    const urlHost = hostName.split(".")[1];
    if (urlHost === this.loginStrings.localhost) {
      window.location.href = this.loginStrings.localHostLogin;
    } else {
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      window.location.href = protocol + "//registration." + domainSuffix;
    }
  }

  loginWithDomainURL(): void {
    this.loginWithSchoolURL = true;
  }

  onLoginWithEmailIdClicked(): void {
    this.loginWithSchoolURL = false;
  }


  checkSession() {
    this.preLoader = true;
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    if (tokenValue) {
      const schoolDomain = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolDomain + this.loginStrings.equalTo));
      let schoolDomainValue = schoolDomain ? schoolDomain.split('=')[1] : null;
      const isFranchiseValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.isFranchise + this.loginStrings.equalTo));
      let isFranchise = isFranchiseValue ? isFranchiseValue.split('=')[1] : null;
      const protocol = window.location.protocol + "//";
      const hostName = window.location.hostname;
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      let redirectUrl = "";
      const schoolVerification = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolVerification + this.loginStrings.equalTo));
      let schoolVerificationValue = schoolVerification ? schoolVerification.split('=')[1] : null;
      if (schoolVerificationValue === this.loginStrings.underVerification) {
        redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsSchoolUnderVerificationPath;
      } else if (schoolVerificationValue === this.loginStrings.step1) {
        redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsSchoolDetailsPath;
      }
      else {
        if (isFranchise === "1") {
          redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsFranchiseDashboardPath;
        } else {
          redirectUrl = protocol + schoolDomainValue + "." + domainSuffix + this.loginStrings.bluewingsDashboardPath;
        }
      }
      setTimeout(() => {
        this.preLoader = false;
      }, 2000);
      window.location.reload();
      window.location.href = redirectUrl;
    }
    this.preLoader = false;
  }


  handleForgotPassword() {
    this.userEmail = '';
    this.isForgotPassword = true;
    this.showPasswordInput = false;
    this.otpVerificationPage = false;
    this.isGoBack = true;
  }
  handleDebounceConfirmPassword(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerConfirmPasswordError(value);
    }, 800);
  }

  triggerConfirmPasswordError(input: any) {
    const confirmNewPasswordInput = input.value.trim();
    this.passwordLength = confirmNewPasswordInput.length;
    this.confirmNewPassword = confirmNewPasswordInput;

  }

  moveToNextForForgotPasswordOTP(event: KeyboardEvent, index: number) {

    const keyPressed = event.key;
    const isNumber = !isNaN(Number(keyPressed));

    // If the key is not a number or backspace, prevent default behavior
    if (!isNumber && event.key !== this.loginStrings.backspace) {
      event.preventDefault();
      return;
    }

    // If the backspace key is pressed and the input field is empty, focus on the previous input field
    if (
      event.key === this.loginStrings.backspace &&
      index > 0 &&
      event.target instanceof HTMLInputElement
    ) {
      const previousInput = document.getElementById(
        "send-otp-input-" + (index - 1)
      ) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
    }

    // If a number key is pressed and the current input field is not the last one, focus on the next input field
    if (isNumber && index < 3) {
      const nextInput = document.getElementById(
        "send-otp-input-" + (index + 1)
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
    this.otpInputsFilled = this.OtpInputsFilled();
  }

  OtpInputsFilled(): boolean {
    return this.otpForForgotPassword.every((input) => input.trim() !== "");
  }


  async sendOptForForgotPassword(isResendOtp) {
    try {
      this.loader = true;
      const body = {
        lang: "en",
        email: this.userEmail,
        domain: null
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationService.sendOtpForResetPassword(body)
      );
      const responseDetails = response as any;

      if (responseDetails.status) {
        customToastr(responseDetails.body.message, this.loginStrings.success)
        this.isResetPassword = true
        this.isForgotPassword = false;
        this.otpVerificationPage = false;
        this.showPasswordInput = false;
        this.countdown = responseDetails.body.attemptLeft;
        this.otpTimerCountdown();
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }

  }



  async resetPassword() {
    try {
      const body = {
        lang: "en",
        email: this.userEmail,
        otp: this.otpForForgotPassword.join(""),
        newPassword: this.password,
        confirmPassword: this.confirmNewPassword
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationService.resetPassword(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        this.otpVerificationPage = false;
        this.showPasswordInput = true;
        this.isResetPassword = false;
        customToastr(responseDetails.body.message, this.loginStrings.success)
        this.clearInputValues();
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          :errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }
  handleGoBack() {
    if (this.isForgotPassword) {
      this.isForgotPassword = false
      this.otpVerificationPage = false;
      this.showPasswordInput = true;
      this.isGoBack = false;
    } else if (this.isResetPassword) {
      this.isForgotPassword = true
    }
    this.userEmail = ''
  }

  
}